import { userPermissions } from '@/common/constants'
import { alertTypes, transactionAlertTexts } from '@/returns/constants'

export const disabledActionInfoSeparator = ' - '

export const availableActions = {
  editCustomsData: 'editCustomsData',
  editAddressAndRetryLabel: 'editAddressAndRetryLabel',
  retryLabel: 'retryLabel',
  issueRefund: 'issueRefund',
  createExchangeOrder: 'createExchangeOrder',
  markAsResolved: 'markAsResolved',
  contactCustomer: 'contactCustomer',
  reviewAdditionalReturnedProducts: 'reviewAdditionalReturnedProducts',
}

export const actionRequiredPermission = {
  [availableActions.editAddressAndRetryLabel]: userPermissions.editReturnLabels,
  [availableActions.retryLabel]: userPermissions.editReturnLabels,
  [availableActions.reviewAdditionalReturnedProducts]: userPermissions.editReturnStatus,
  [availableActions.createExchangeOrder]: userPermissions.editExchangeOrders,
  [availableActions.issueRefund]: userPermissions.editIssueRefund,
}

export const markAsResolvedRequiredPermission = {
  [alertTypes.refundOnHold]: userPermissions.editIssueRefund,
  [alertTypes.exchangeOnHold]: userPermissions.editExchangeOrders,
}

export const availableAlerts = [
  {
    code: alertTypes.missingCustomsData,
    title: transactionAlertTexts[alertTypes.missingCustomsData],
    availableActions: [availableActions.editCustomsData],
  },
  {
    code: alertTypes.wrongAddress,
    title: transactionAlertTexts[alertTypes.wrongAddress],
    availableActions: [availableActions.editAddressAndRetryLabel],
  },
  {
    code: alertTypes.incompleteAddress,
    title: transactionAlertTexts[alertTypes.incompleteAddress],
    availableActions: [availableActions.editAddressAndRetryLabel],
  },
  {
    code: alertTypes.labelCreationError,
    title: transactionAlertTexts[alertTypes.labelCreationError],
    availableActions: [availableActions.retryLabel],
  },
  {
    code: alertTypes.pickupCreationError,
    title: transactionAlertTexts[alertTypes.pickupCreationError],
    availableActions: [availableActions.retryLabel],
  },
  {
    code: alertTypes.refundOnHold,
    title: transactionAlertTexts[alertTypes.refundOnHold],
    availableActions: [availableActions.issueRefund, availableActions.markAsResolved],
  },
  {
    code: alertTypes.exchangeOnHold,
    title: transactionAlertTexts[alertTypes.exchangeOnHold],
    availableActions: [availableActions.createExchangeOrder, availableActions.markAsResolved],
  },
  {
    code: alertTypes.exchangeOrderError,
    title: transactionAlertTexts[alertTypes.exchangeOrderError],
    availableActions: [availableActions.createExchangeOrder, availableActions.markAsResolved],
  },
  {
    code: alertTypes.rtsParcelExported,
    title: transactionAlertTexts[alertTypes.rtsParcelExported],
    availableActions: [],
  },
  {
    code: alertTypes.rtsPaymentFailed,
    title: transactionAlertTexts[alertTypes.rtsPaymentFailed],
    availableActions: [],
  },
  {
    code: alertTypes.rtsWrongAddress,
    title: transactionAlertTexts[alertTypes.rtsWrongAddress],
    availableActions: [],
  },
  {
    code: alertTypes.rtsUnknownRecipient,
    title: transactionAlertTexts[alertTypes.rtsUnknownRecipient],
    availableActions: [],
  },
  {
    code: alertTypes.rtsDamaged,
    title: transactionAlertTexts[alertTypes.rtsDamaged],
    availableActions: [],
  },
  {
    code: alertTypes.rtsNotPickUpByRecipient,
    title: transactionAlertTexts[alertTypes.rtsNotPickUpByRecipient],
    availableActions: [],
  },
  {
    code: alertTypes.rtsFeesRefusedByRecipient,
    title: transactionAlertTexts[alertTypes.rtsFeesRefusedByRecipient],
    availableActions: [],
  },
  {
    code: alertTypes.rtsProhibitedContent,
    title: transactionAlertTexts[alertTypes.rtsProhibitedContent],
    availableActions: [],
  },
  {
    code: alertTypes.rtsInTransit,
    title: transactionAlertTexts[alertTypes.rtsInTransit],
    availableActions: [],
  },
  {
    code: alertTypes.rtsRefusedByRecipient,
    title: transactionAlertTexts[alertTypes.rtsRefusedByRecipient],
    availableActions: [],
  },
  {
    code: alertTypes.rtsDelivered,
    title: transactionAlertTexts[alertTypes.rtsDelivered],
    availableActions: [],
  },
  {
    code: alertTypes.negativeSentiment,
    title: transactionAlertTexts[alertTypes.negativeSentiment],
    availableActions: [availableActions.contactCustomer, availableActions.markAsResolved],
  },
  {
    code: alertTypes.timeIssue,
    title: transactionAlertTexts[alertTypes.timeIssue],
    availableActions: [availableActions.contactCustomer, availableActions.markAsResolved],
  },
  {
    code: alertTypes.unexpectedItems,
    title: transactionAlertTexts[alertTypes.unexpectedItems],
    availableActions: [availableActions.reviewAdditionalReturnedProducts],
  },
]
